export default {"src":"/_next/static/media/statistics.b1a91244.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};